import { ModalErrorConfig } from '@core/interfaces/modal-error-config.interface';

export const SHOW_APPS_CONFIG_FTD: ModalErrorConfig = {
  imageUrl: {
    url: 'assets/img/errors/error__gotoapp.svg',
    altUrl: 'Information for error attemps icon/illustration',
  },
  errorTitle: 'Puedes continuar todo desde la APP. ¡Vamos allá!',
  errorDescription:
    'Antes de avanzar con tu Depósito a Plazo Fijo, necesitamos completar tu usuario digital. Descarga la app aquí:',
  buttonLabel: 'Ir al App Banco Pichincha',
};

export const URL_APP_DOWNLOAD =
  'https://www.pichincha.pe/personas/productos-y-servicios/Beneficios-Canales-Digitales/APP';

export const URL_APP_STORE = {
  GOOGLE_PLAY: 'https://play.google.com/store/apps/details?id=pe.pichincha.bm',
  HUAWEI_STORE: 'https://appgallery.huawei.com/app/C107405799',
  APPLE_STORE: 'https://apps.apple.com/us/app/id1476717951',
};
